import { statisticsRepository } from '@/infrastructure/repositories';
import {
  DashboardStatistics,
  ProductStatistics,
  OrderStatistics,
  ChartData,
} from '@/domain/entities';

export class StatisticsService {
  async getDashboard(): Promise<DashboardStatistics> {
    return statisticsRepository.getDashboard();
  }

  async getProducts(): Promise<ProductStatistics> {
    return statisticsRepository.getProducts();
  }

  async getOrders(): Promise<OrderStatistics> {
    return statisticsRepository.getOrders();
  }

  async getOrdersChart(): Promise<ChartData> {
    return statisticsRepository.getOrdersChart();
  }
}

export const statisticsService = new StatisticsService();

